module.exports = __webpack_public_path__ + "static/pexels-photo-1251855-compressor-29a0b2c2fb1cce93e598d5f20635c368.jpg";